export default __webpack_public_path__ + "28e6f5b8e46f9b56d5e435a37f5c630d.jpg";